/**
 * Centralized dayjs setup with UTC plugin.
 * Handles ESM/CommonJS interop for Jest and other environments.
 */
import _dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

const dayjs = (_dayjs as { default?: typeof _dayjs })?.default ?? _dayjs;
if (dayjs?.extend) {
  dayjs.extend(utc);
}

export default dayjs;
